var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.token.isPriceVariationEmpty)?_c('div'):_c('div',{staticClass:"w-auto"},[_c('e-charts',{staticClass:"children:w-auto token-price-chat__chart",attrs:{"autoresize":true,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }